import { render, staticRenderFns } from "./SelectTownDropdown.vue?vue&type=template&id=784a1a78&scoped=true"
import script from "./SelectTownDropdown.vue?vue&type=script&lang=js"
export * from "./SelectTownDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784a1a78",
  null
  
)

export default component.exports